import { Option, TimeUnit } from '@urbanx/agx-ui-components';
import { DropdownOption } from '@urbanx/agx.ui-components2';

const inLineWithText = 'In line with ';

export enum SettlementInLineWithType {
  BuyersProperty = "settlement of the Buyer's property",
  VendorsPurchase = "settlement of the Vendor's purchase",
  TenancyAgreement = 'end date of existing Tenancy Agreement',
}

export const SettlementInLineWithOptions = [
  {
    label: SettlementInLineWithType.BuyersProperty,
    value: `${inLineWithText}${SettlementInLineWithType.BuyersProperty}`,
  },
  {
    label: SettlementInLineWithType.VendorsPurchase,
    value: `${inLineWithText}${SettlementInLineWithType.VendorsPurchase}`,
  },
  {
    label: SettlementInLineWithType.TenancyAgreement,
    value: `${inLineWithText}${SettlementInLineWithType.TenancyAgreement}`,
  },
];

export const TimeOptions: DropdownOption[] = [
  {
    value: TimeUnit.Days.toString(),
    label: 'days',
  },
  {
    value: TimeUnit.Weeks.toString(),
    label: 'weeks',
  },
];
